import { render, staticRenderFns } from "./base-dialog.vue?vue&type=template&id=69af4f64&"
import script from "./base-dialog.vue?vue&type=script&lang=ts&"
export * from "./base-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports